import React from 'react';
import {
	Card as MuiCard,
	CardActionArea,
	CardContent,
	CardHeader,
	IconButton,
	Typography,
	CircularProgress,
} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {CardProps} from './types';
import {useCard} from './useCard';

const {selectedRecent} = translations['pt-br'].commons;

export function Card({
	item,
	recentlyVisited,
	isLoading,
	handleContextMenuOpen,
	handleCardClick,
}: CardProps) {
	const {colors, getRightIcon, handleCardKeyDown, formattedAddress} = useCard({
		item,
		handleCardClick,
	});

	return (
		<MuiCard elevation={0} sx={{height: '100%'}}>
			<CardActionArea
				disabled={isLoading}
				sx={{height: '100%'}}
				component="div"
				role="button"
				tabIndex={0}
				onClick={() => handleCardClick(item)}
				onKeyDown={event => handleCardKeyDown(event, item)}>
				<CardHeader
					avatar={
						isLoading ? (
							<CircularProgress size={24} />
						) : (
							<Icon
								name={getRightIcon(item.address.nmLocal)}
								color={colors.brand.primary.blue}
							/>
						)
					}
					action={
						<IconButton
							size="small"
							sx={{rotate: '90deg'}}
							onClick={event => handleContextMenuOpen(event, item)}>
							<Icon name="more-horiz-filled" color={colors.brand.primary.blue} />
						</IconButton>
					}
					title={<Typography variant="subheader">{item.address.nmLocal}</Typography>}
					subheader={
						<Typography variant="body2" color="text.secondary">
							{formattedAddress}
						</Typography>
					}
				/>
				{recentlyVisited && (
					<CardContent
						sx={{
							paddingY: 1,
							paddingX: 2,
							backgroundColor: colors.light.info['190Percent'],
						}}>
						<Typography variant="body2" color={colors.light.info['160Percent']}>
							{selectedRecent}
						</Typography>
					</CardContent>
				)}
			</CardActionArea>
		</MuiCard>
	);
}
